
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { Vehicle } from '@/lib/models/Vehicle'
import { VehicleClass } from '@/lib/models/VehicleClass'
import { Rally } from '@/lib/models/Rally'
import { FileCheck } from '@/lib/utils/FileCheck'

import BacButton from '@/components/BacButton.vue'
import BacEditableMinioImage from '@/components/BacEditableMinioImage.vue'
import BacMultiselectWrapper from '@/components/BacMultiselectWrapper.vue'
import VehicleNonPublicInfo from './VehicleNonPublicInfo.vue'
import Multiselect from 'vue-multiselect'

import UIkit from 'uikit'
import { RallyRound } from '../../lib/models/RallyRound'
import { Http } from '@/lib/utils/Http'
import { MinioRessource } from '../../lib/models/MinioRessource'

@Component({
  components: {
    BacEditableMinioImage,
    BacButton,
    BacMultiselectWrapper,
    Multiselect,
    VehicleNonPublicInfo
  }
})
export default class VehicleComponent extends Vue {
  @Prop({ default: false }) editMode!: boolean
  @Prop({ default: false }) canAddNew!: boolean

  @Prop({ default: () => new Vehicle() }) vehicleInstance!: Vehicle
  @Prop({ required: true }) rally!: Rally

  selectedVehicleClasses = [];
  vehicleImageUrl = '';

  @Watch('selectedVehicleClasses')
  onSelectedVehicleClassesChanged () {
    if (this.editMode) {
      this.save(false)
    }
  }

  @Watch('vehicleInstance')
  onVehicleChanged () {
    // set selected vehicle classes from api data
    if (this.vehicle.classes) {
      (this.selectedVehicleClasses as any) = this.vehicle.classes.map(vehicleClass => {
        if (vehicleClass.class) {
          return vehicleClass.class.name
        }
      })
    }
    this.imageChanged(false)
  }

  async imageSaved (data: any) {
    this.vehicleInstance.imageId = data.id
    await this.vehicleInstance.update()
    this.imageChanged()
  }

  async imageDeleted () {
    this.vehicleInstance.imageId = null
    await this.vehicleInstance.update()
    this.imageChanged()
  }

  async updateVehicleClasses (): Promise<boolean> {
    const res = await Http.request(`/api/vehicle/${this.vehicle.id}/classes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.selectedVehicleClassesId)
    })
    return res.status === 200
  }

  get selectedVehicleClassesId () {
    return this.selectedVehicleClasses.map((className: string) => {
      const vehicleClass = this.rally.vehicleClasses.find((vehicleClass: VehicleClass) => {
        return vehicleClass.name === className
      })
      if (vehicleClass) {
        return vehicleClass.id
      }
    })
  }

  get vehicle () {
    return this.vehicleInstance ?? new Vehicle()
  }

  mounted () {
    this.vehicleImageUrl = ''
    this.imageChanged()
  }

  /* @Watch('$store.state.PageURLTeam.team')
  onTeamChanged () {
    this.reloadImage()
  } */

  async imageChanged (loadTeam = true) {
    if (this.vehicleInstance.imageId) {
      const imagePath = (await MinioRessource.get(this.vehicleInstance.imageId)).path
      if (imagePath) {
        this.vehicleImageUrl = imagePath
      }
    } else {
      this.vehicleImageUrl = require('@/assets/img/rally/default-vehicle-images/car.jpg')
      if (this.$store.state.PageURLRally.rally.id === 6) {
        this.vehicleImageUrl = require('@/assets/img/rally/default-vehicle-images/moped.jpg')
      } else if (this.$store.state.PageURLRally.rally.id === 9) {
        this.vehicleImageUrl = require('@/assets/img/rally/default-vehicle-images/boat.jpg')
      }
    }
    if (loadTeam) {
      this.$store.dispatch('loadTeam', this.$route.params.teamId)
    }
  }

  /* async reloadImage () {
    if (this.vehicle && this.vehicle.images && this.vehicle.images.length) {
      this.vehicleImageUrl = `/teamarea/data/team/vehicle-images/${this.vehicle.images[0].image_path}` +
          '?' +
          Math.round(Math.random() * 10000)
    } else {
      if (await FileCheck.doesImageExist(`/teamarea/data/vehicle.${this.rally.id}.jpg`)) {
        this.vehicleImageUrl = `/teamarea/data/vehicle.${this.rally.id}.jpg`
      } else {
        this.vehicleImageUrl = '/teamarea/data/vehicle.jpg'
      }
    }
  } */

  /**
   * This function is called whenever a user input (e.g. from a textbox) is changed.
   * The data is debounced (no change happens for a certain period of time) the save function is called
   */
  private saveTimeout = 0;
  private inputChanged () {
    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout)
    }
    this.saveTimeout = setTimeout(this.save, 1000)
  }

  async save (showConfirmation = true) {
    try {
      let success = true
      success = success && await this.vehicle.update()
      success = success && await this.updateVehicleClasses()
      if (!success) {
        throw new Error('an unknown error happened while updating!')
      }
      if (success) {
        if (showConfirmation) {
          this.$emit('saveNotification')
        }
      }
    } catch (ex) {
      console.error(ex)
      UIkit.notification({
        message:
          'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    }
  }

  async deleteVehicle () {
    if (!this.vehicleInstance.id || !parseInt((this.vehicleInstance as any).id)) {
      return
    }
    await Vehicle.delete(this.vehicleInstance.id)
    this.$store.dispatch('loadTeam', this.$route.params.teamId)
    this.$emit('saveNotification')
  }
}
